export default "__VITE_ASSET__DUGJzLU8__"